function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar with time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63,393V160H33V393a33.038,33.038,0,0,0,33,33H96A33.038,33.038,0,0,1,63,393Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,86.621V83H65a33.038,33.038,0,0,0-33,33v33H62V116A33.028,33.028,0,0,1,80,86.621Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.156,240.133h38a11.012,11.012,0,0,0,11-11v-38a11.012,11.012,0,0,0-11-11h-38a11.013,11.013,0,0,0-11,11v38A11.012,11.012,0,0,0,59.156,240.133Zm3-46h32v32h-32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.156,191.133v38a11.012,11.012,0,0,0,11,11h38a11.012,11.012,0,0,0,11-11v-38a11.012,11.012,0,0,0-11-11h-38A11.013,11.013,0,0,0,124.156,191.133Zm14,3h32v32h-32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.156,240.133h38a11.012,11.012,0,0,0,11-11v-38a11.012,11.012,0,0,0-11-11h-38a11.013,11.013,0,0,0-11,11v38A11.012,11.012,0,0,0,212.156,240.133Zm3-46h32v32h-32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.156,240.133h38a11.012,11.012,0,0,0,11-11v-38a11.012,11.012,0,0,0-11-11h-38a11.013,11.013,0,0,0-11,11v38A11.012,11.012,0,0,0,288.156,240.133Zm3-46h32v32h-32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.156,191.133v38a11.012,11.012,0,0,0,11,11h38a11.012,11.012,0,0,0,11-11v-38a11.012,11.012,0,0,0-11-11h-38A11.013,11.013,0,0,0,354.156,191.133Zm14,3h32v32h-32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.156,325.133h38a11.012,11.012,0,0,0,11-11v-38a11.012,11.012,0,0,0-11-11h-38a11.013,11.013,0,0,0-11,11v38A11.012,11.012,0,0,0,60.156,325.133Zm3-46h32v32h-32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.156,265.133h-38a11.013,11.013,0,0,0-11,11v38a11.012,11.012,0,0,0,11,11h38a11.012,11.012,0,0,0,11-11v-38A11.012,11.012,0,0,0,174.156,265.133Zm-3,46h-32v-32h32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.156,265.133h-38a11.013,11.013,0,0,0-11,11v38a11.012,11.012,0,0,0,11,11h38a11.012,11.012,0,0,0,11-11v-38A11.012,11.012,0,0,0,251.156,265.133Zm-3,46h-32v-32h32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.156,394.133a11.012,11.012,0,0,0,11,11h38a11.012,11.012,0,0,0,11-11v-39a11.012,11.012,0,0,0-11-11h-38a11.013,11.013,0,0,0-11,11Zm14-36h32v33h-32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.156,405.133a11.012,11.012,0,0,0,11-11v-39a11.012,11.012,0,0,0-11-11h-38a11.013,11.013,0,0,0-11,11v39a11.012,11.012,0,0,0,11,11Zm-35-47h32v33h-32Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.156,295.133a7,7,0,0,0,7-7v-12a11.012,11.012,0,0,0-11-11h-38a11.013,11.013,0,0,0-11,11v38a11.012,11.012,0,0,0,11,11h11a7,7,0,0,0,0-14h-8v-32h32v9A7,7,0,0,0,331.156,295.133Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.724,410.645a6.965,6.965,0,0,0,3.665-1.041l48.438-29.834a7,7,0,0,0,3.329-5.96V297.133a7,7,0,0,0-14,0V369.9l-45.109,27.783a7,7,0,0,0,3.677,12.962Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.055,120.133h4.2a24.927,24.927,0,0,0,24.9-24.9v-40.2a24.927,24.927,0,0,0-24.9-24.9h-4.2a24.928,24.928,0,0,0-24.9,24.9v40.2A24.928,24.928,0,0,0,99.055,120.133Zm-10.9-65.1a10.912,10.912,0,0,1,10.9-10.9h4.2a10.912,10.912,0,0,1,10.9,10.9v40.2a10.911,10.911,0,0,1-10.9,10.9h-4.2a10.911,10.911,0,0,1-10.9-10.9Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.055,120.133h4.2a24.927,24.927,0,0,0,24.9-24.9v-40.2a24.927,24.927,0,0,0-24.9-24.9h-4.2a24.928,24.928,0,0,0-24.9,24.9v40.2A24.928,24.928,0,0,0,359.055,120.133Zm-10.9-65.1a10.912,10.912,0,0,1,10.9-10.9h4.2a10.912,10.912,0,0,1,10.9,10.9v40.2a10.911,10.911,0,0,1-10.9,10.9h-4.2a10.911,10.911,0,0,1-10.9-10.9Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.156,89.133h219a7,7,0,0,0,0-14h-219a7,7,0,0,0,0,14Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.156,282.913V117.68c0-23.858-18.2-42.547-41.437-42.547H381.156a7,7,0,0,0,0,14h21.563c15.385,0,27.437,12.539,27.437,28.547v28.453h-398V117.68c0-15.207,14.246-28.547,30.485-28.547H81.156a7,7,0,0,0,0-14H62.641c-24.113,0-44.485,19.484-44.485,42.547V395.112c0,23.32,20.372,43.021,44.485,43.021H299.015a108.025,108.025,0,1,0,145.141-155.22ZM62.641,424.133c-16.239,0-30.485-13.561-30.485-29.021V160.133h398V275.288A108.028,108.028,0,0,0,290.188,424.133Zm323.146,43.734a94.057,94.057,0,1,1,94.057-94.056A94.164,94.164,0,0,1,385.787,467.867Z",
    style: {
      fill: "#2f55d4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4e53ec1a4887f39d673fe2d90962ae86.svg";
export { ForwardRef as ReactComponent };